import { combineReducers } from 'redux'
import env from './env'
import layout from './layout'
import locale from './locale'
import license from './license'
import config from './config'
import users from './users'
import spUsers from './spUsers'
import userAvatars from './userAvatars'
import userGroups from './userGroups'
import currentUser from './currentUser'
import notifications from './notifications'
import documentSources from './documentSources'
import toasts from './toasts'
import unsavedChanges from './unsavedChanges'
import followedCards from './followedCards'
import version from './version'
import localSettings from './localSettings'
import personalDates from './personalDates'
import search from './search'
import incomingMails from './incomingMails'
import bookmarks from './bookmarks'
import cardRelations from './cardRelations'
import boardInfo from './boardInfo'
import alarms from './alarms'
import userActivities from './userActivities'
import heartbeats from './heartbeats'
import boards from './boards'
import userRoles from './userRoles'
import documentTemplateSources from './documentTemplateSources'
import blockers from './blockers'
import cardBlockers from './cardBlockers'
import userBlockers from './userBlockers'
import descendantBlockedCards from './descendantBlockedCards'
import previousBlockedCards from './previousBlockedCards'
import observedTags from './observedTags'
import branding from './branding'

export default combineReducers({
  env,
  layout,
  locale,
  license,
  config,
  users,
  spUsers,
  userAvatars,
  userGroups,
  currentUser,
  notifications,
  documentSources,
  toasts,
  unsavedChanges,
  followedCards,
  version,
  localSettings,
  personalDates,
  search,
  incomingMails,
  bookmarks,
  cardRelations,
  boardInfo,
  alarms,
  userActivities,
  heartbeats,
  boardsById: boards,
  userRoles,
  documentTemplateSources,
  blockers,
  cardBlockers,
  userBlockers,
  descendantBlockedCards,
  previousBlockedCards,
  observedTags,
  branding,
})
